import { Lock, Sparkles } from "lucide-react";
import React, { useState } from "react";

import { Link } from "@/lib/i18n";
import { cn } from "@/lib/utils";
import * as m from "@/paraglide/messages";
import { useAppSelector } from "@/services/hooks/redux.hooks";

import { Button } from "./ui/button";

export function UnlockButton() {
  const { can_have_trail } = useAppSelector((state) => state.user);
  const [isHovering, setIsHovering] = useState(false);
  if (can_have_trail) {
    return (
      <Link href="/checkout?trial=true" className="mt-auto">
        <Button
          asChild
          className="w-full"
          variant="gooeyLeft"
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
        >
          <span>
            <div className="flex items-center justify-center gap-2 relative z-10">
              <div className="relative">
                <Lock
                  className={cn(
                    "w-4 h-4 transition-all duration-300",
                    isHovering ? "opacity-0 scale-50" : "opacity-100 scale-100",
                  )}
                />
                <Sparkles
                  className={cn(
                    "w-4 h-4 absolute top-0 left-0 transition-all duration-300",
                    isHovering ? "opacity-100 scale-100" : "opacity-0 scale-50",
                  )}
                />
              </div>
              <span>{m.maroon_candid_flea_pick()}</span>
            </div>

            {/* Subtle background effect */}
            <div className="absolute inset-0 bg-zinc-900 opacity-0 group-hover:opacity-30 transition-opacity duration-300"></div>

            {/* Shine effect */}
            <div
              className={cn(
                "absolute top-0 -left-[100%] w-1/3 h-full bg-white/10 skew-x-12 transition-all duration-700 ease-in-out",
                isHovering ? "left-[200%]" : "-left-[100%]",
              )}
            />
          </span>
        </Button>
      </Link>
    );
  }

  return (
    <Link className={cn("h-12 relative ring-0 w-full")} href={`/pricing`}>
      <Button
        asChild
        className="w-full"
        variant="gooeyLeft"
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        <span>
          <div className="flex items-center justify-center gap-2 relative z-10">
            <div className="relative">
              <Lock
                className={cn(
                  "w-4 h-4 transition-all duration-300",
                  isHovering ? "opacity-0 scale-50" : "opacity-100 scale-100",
                )}
              />
              <Sparkles
                className={cn(
                  "w-4 h-4 absolute top-0 left-0 transition-all duration-300",
                  isHovering ? "opacity-100 scale-100" : "opacity-0 scale-50",
                )}
              />
            </div>
            <span>{m.maroon_candid_flea_pick()}</span>
          </div>

          {/* Subtle background effect */}
          <div className="absolute inset-0 bg-zinc-900 opacity-0 group-hover:opacity-30 transition-opacity duration-300"></div>

          {/* Shine effect */}
          <div
            className={cn(
              "absolute top-0 -left-[100%] w-1/3 h-full bg-white/10 skew-x-12 transition-all duration-700 ease-in-out",
              isHovering ? "left-[200%]" : "-left-[100%]",
            )}
          />
        </span>
      </Button>
    </Link>
  );
}
